import { render, staticRenderFns } from "./projectContribution.vue?vue&type=template&id=80be1a90&scoped=true&"
import script from "./projectContribution.vue?vue&type=script&lang=tsx&"
export * from "./projectContribution.vue?vue&type=script&lang=tsx&"
import style0 from "./projectContribution.vue?vue&type=style&index=0&id=80be1a90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80be1a90",
  null
  
)

export default component.exports